module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_family@2x-ee03e33f895b9256f3da2ac961a57e10.webp";